var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-arrow',{ref:"lien",attrs:{"config":{
                name:_vm.linkObj.data.ref,
                points:_vm.radiusAjuste,
                stroke:this.linkObj.data.color,
                strokeWidth: 10,
                listening:false,
                perfectDrawEnabled:_vm.nothingIsMoving,
            }}}),(_vm.nothingIsMoving)?_c('v-rect',{attrs:{"config":{
                  x : _vm.centerOfLine.x,
                  y: _vm.centerOfLine.y,
                  width:300,
                  height:30,
                  offsetX:150,
                  offsetY:22,
                  rotation:_vm.getAngle,
                  listening:false,
                  }},on:{"click":_vm.editLink}}):_vm._e(),(_vm.nothingIsMoving)?_c('v-text',{attrs:{"config":{
                  x : _vm.centerOfLine.x,
                  y: _vm.centerOfLine.y,
                  offsetX:150,
                  offsetY:22,
                  fill: 'black',
                  text: _vm.getText,
                  fontSize: 20,
                  fontStyle:'bold',
                  align:'center',
                  width: 300,
                  rotation:_vm.getAngle,
                  listening:false,
                  }},on:{"click":_vm.editLink}}):_vm._e(),(_vm.nothingIsMoving)?_c('v-image',{attrs:{"config":{
                  x : _vm.radiusAjuste[0]-8,
                  y: _vm.radiusAjuste[1]-8,
                  image:_vm.imgClose,
                  }},on:{"click":_vm.deleteLink}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }